module.exports = __webpack_public_path__ + "782d494eb76f9a7ae90ed678d1abc296.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/minimal-wave.jpg
 ** module id = 484
 ** module chunks = 0
 **/